import client from "../libs/HttpClient";
class GeneralsettingService {
  static getGeneralsettingData() {
    return client.get("/general-setting-list");
  }
  
}
export { GeneralsettingService };